import './Button.css';
import React from 'react';
import { clsx } from 'clsx';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className = 'transparent', onClick, type, form, disabled, ...props }, ref) => {
    return (
      <>
        <button
          {...props}
          ref={ref}
          className={clsx(
            className,
            'button mt-2.5 w-full md:px-[20px] md:py-[10px] py-[8px] px-[15px] md:h-[45px] h-[31px]',
            disabled && 'disabled',
          )}
          onClick={onClick}
          type={type}
          form={form}
          disabled={disabled}
        >
          {children}
        </button>
      </>
    );
  },
);

Button.displayName = 'Button';

export default Button;
